module.exports = __webpack_public_path__ + "media/images/product_owners/dss_90-be53f8ddeeac011c7ec58023ced19ce7.png";